import { render, staticRenderFns } from "./RankReward.vue?vue&type=template&id=58e20dbe&"
import script from "./RankReward.vue?vue&type=script&lang=js&"
export * from "./RankReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports